import { Link } from "react-router-dom";

export default function PaymentFailed() {
  return (
    <main className="min-h-screen bg-[#21150D] text-[#F5EAD8] flex items-center justify-center px-6">
      <section className="w-full max-w-xl text-center">
        <div className="text-xs uppercase tracking-[0.25em] text-[#C9A84C]">Anokina Studio</div>
        <h1 className="font-serif text-4xl mt-4">Оплата не завершена</h1>
        <p className="mt-5 text-[#F5EAD8]/70">
          Доступ не изменён. Вы можете вернуться к продуктам и повторить оплату позже.
        </p>
        <Link to="/programs" className="inline-block mt-8 underline underline-offset-4">
          Вернуться к программам
        </Link>
      </section>
    </main>
  );
}
